export enum ErrorType {
    BusinessLogic = 'business-logic',
    Validation = 'validation',
    SchemaValidation = 'schema-validation',
    Forbidden = 'forbidden',
    Unauthorized = 'unauthorized',
    Configuration = 'configuration',
}
